import React from 'react';
import { Timer as HeaderTimer } from '@pegasus/ui-headers';
import { CartStatusEnum, Cart } from '@pegasus/cart';
import { useTimer } from '@pegasus/cart';

export interface Props {
    cart?: Cart;
    setTimerState: (status: CartStatusEnum) => void;
    onExpiredCart: () => void;
}

export const Timer = ({ cart, setTimerState, onExpiredCart }: Props) => {
    const { counter } = useTimer(cart, {
        onCartExpiresFirstWarning: () => {
            setTimerState(CartStatusEnum.CART_EXPIRE_IN_5_MINUTES);
        },
        onCartExpiresSecondWarning: () => {
            setTimerState(CartStatusEnum.CART_EXPIRE_IN_SHORT_PERIOD);
        },
        onCartExpiresLastWarning: () => {
            setTimerState(CartStatusEnum.CART_EXPIRE_IN_SHORT_PERIOD);
        },
        onCartExpired: () => {
            setTimerState(CartStatusEnum.CART_EXPIRED);
            onExpiredCart();
        },
    });

    return <HeaderTimer timeLeft={counter} />;
};
